<template>
  <span class="t-expandable-text">
    <span data-testid="expandable-text-content">{{ displayText }}</span>
    <TMTertiaryButton
      v-if="needsTruncation"
      name="expandable-text-toggle"
      class="inline-flex p-0 ml-1"
      :label="toggleLabel"
      :icon="showIcon ? toggleIcon : undefined"
      icon-pos="right"
      @click="toggle"
    />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TMTertiaryButton from '../../button/TMTertiaryButton.vue'
import { setup } from './controller'
import { T_EXPANDABLE_TEXT_PROPS } from './types'

export default defineComponent({
  name: 'TExpandableText',
  components: {
    TMTertiaryButton,
  },
  props: T_EXPANDABLE_TEXT_PROPS,
  setup,
})
</script>
